<template>
  <div class="chart-page">
    <p class="page-title">그래프</p>

    <div :class="{ isDisplay: isEmptyObject(matchInfo) }">
      <div class="chart-div">
        <div class="ball">
          <p>볼 점유율</p>
          <PieChart v-bind:per-data="ballData" v-bind:chart-options="chartOptions"
          />
        </div>
        <div class="shooting">
          <p>유효 슈팅율</p>
          <PieChart v-bind:per-data="shootingData" v-bind:chart-options="chartOptions"/>
        </div>
      </div>

      <ul class="item-div">
        <li>
          <div class="circle home"></div>
          <span>
          {{ matchInfo.home_team === 'K07' ? matchInfo.home_team_full_name : matchInfo.away_team_full_name }}
        </span>
        </li>
        <li>
          <div class="circle"></div>
          <span>
          {{ matchInfo.home_team === 'K07' ? matchInfo.away_team_full_name : matchInfo.home_team_full_name }}
        </span>
        </li>
      </ul>
    </div>
    <MatchNotFound v-if="isEmptyObject(matchInfo)" :title="'경기 기록'" />
  </div>
</template>

<script>
import PieChart from '@/components/Common/PieChart.vue';
import MatchNotFound from '@/components/Ticket/MatchNotFound.vue';

export default {
  name: 'MatchChart',
  props: {
    game: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    MatchNotFound,
    PieChart
  },
  watch: {
    game: {
      handler: function () {
        this.matchInfo = this.game;
        this.setInfo();
      },
      deep: true
    }
  },
  data() {
    return {
      matchInfo: {},
      info: {},
      ballData: [0,0],
      shootingData: [0,0],
      chartDataBall: {
        datasets: [
          {
            backgroundColor: ['#F5F5F5', '#FFCD00'],
            data: [60, 40]
          }
        ]
      },
      chartOptions: {
        tooltips: false,
        responsive: true,
        maintainAspectRatio: false,
        hover: false,
        elements: {
          arc: {
            borderWidth: 1,
            borderColor:'#ddd'
          }
        },
        plugins: {
          datalabels: {
            color: function(context) {
              return context.dataIndex === 0 ? '#999' : '#000';
            },
            textAlign: 'center',
            font: function (context) {
              const size = window.innerWidth < 960 ? 14 : 24
              return {
                size: size,
                weight: 700,
              }
            },
            formatter: function (value) {
              return value + `%`;
            }.bind(this)
          }
        }
      }
    }
  },
  mounted () {
    // console.log('=========>', this.matchInfo);
  },
  methods: {
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    },
    setInfo() {

      const home_valid_qty_per = (this.matchInfo.home_st_valid_qty / (this.matchInfo.home_st_valid_qty + this.matchInfo.away_st_valid_qty)) * 100;
      const away_valid_qty_per = (this.matchInfo.away_st_valid_qty / (this.matchInfo.home_st_valid_qty + this.matchInfo.away_st_valid_qty)) * 100;

      this.info = {
        home_team_name: this.matchInfo.home_team_name,
        home_team: this.matchInfo.home_team,
        home_ball_per: Math.round(this.matchInfo.home_Team_Time_share),
        home_shooting_per: Math.round(home_valid_qty_per),
        away_team_name: this.matchInfo.away_team_name,
        away_team: this.matchInfo.away_team,
        away_ball_per: Math.round(this.matchInfo.away_Team_Time_share),
        away_shooting_per: Math.round(away_valid_qty_per),
      }

      if(this.matchInfo.home_team === 'K07') {
        this.ballData = [this.info.away_ball_per, this.info.home_ball_per];
        this.shootingData = [this.info.away_shooting_per, this.info.home_shooting_per];
      } else {
        this.ballData = [this.info.home_ball_per, this.info.away_ball_per];
        this.shootingData = [this.info.home_shooting_per, this.info.away_shooting_per];
      }





      // console.log('ball', this.ballData);
      // console.log('shoot', this.shootingData);
    },
  }
}
</script>

<style scoped>
.isDisplay {
  display: none;
}
</style>
